(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-jo"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.querySelector('#shopify-section-{{ section.id }} #ft-{{ section.id }}');
  if(!root) return;
  var enableAcc = root.getAttribute('data-mobile-acc') === 'true';
  if(!enableAcc) return;

  var mq = window.matchMedia('(max-width: 767px)');
  var details = root.querySelectorAll('details.ft-acc');
  function apply(){
    details.forEach(function(d){ if (mq.matches){ d.open = false; } else { d.open = true; } });
  }
  apply();
  if (mq.addEventListener){ mq.addEventListener('change', apply); } else { mq.addListener(apply); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
